<common-top-tool-bar [title]="this.book_id ? '编辑' : '新增'+'绘本 Reading'"
                     [back]="'/admin/v3/resource/'+bisType+'/edit/'+book_id"
                     [query]="{tabIndex: 1}"
                     [actionsTemplate]="actions">
  <ng-template #actions>
    <button nz-button [nzType]="'primary'" class="mr-4"
            [nzSize]="'large'" nzGhost
            [queryParams]="{ tabIndex: 1 }"
            [routerLink]="'/admin/v3/resource/'+bisType+'/edit/'+book_id+'/index'">
      取消
    </button>
    <button nz-button [nzType]="'primary'"
            [nzSize]="'large'"
            (click)="saveCoursewareOidOPackage()">
      {{this.book_id ? '保存' : '确定新增' }}
    </button>
  </ng-template>
</common-top-tool-bar>





<div class="page-main">
  <nz-spin [nzSpinning]="isLoading">
    <div class="page-main-table">
      <div class="table-header"></div>
      <nz-tabs nzType="line"
                 [nzTabPosition]="'left'"
                 [nzSelectedIndex]="currentPageIndex"
                 (nzSelectedIndexChange)="pageIndexChange($event)">


        <nz-tab *ngFor="let page of factory_pages;
                let i = index" [nzClosable]="false"
                [nzTitle]="titleTemplate">

          <ng-template #titleTemplate>
            <div style="font-size: 14px">
              <div class="px-2"></div>
              {{ '页码'+(i + 1) }}
            </div>
          </ng-template>
          <ng-template nz-tab>
          <div class="p-8" style="padding-left: 8px;">
            <div nz-row>
              <div nz-col [nzSpan]="getPicAspectRatio(page) > 1 ? 16 : 8">
                <nz-affix [nzOffsetTop]="150"  #affix>
                <div
                  *ngIf="page.image_area.images[0].img_width && page.image_area.images[0].img_height"
                  #containerRef
                  id="boundingContainerDiv"
                  class="w-full h-auto img-editor overflow-hidden relative"
                  [ngStyle]="{
                  'width': 100+'%',
                  'aspect-ratio': getPicAspectRatio(page),
                  'background-image': 'url(' + (page.image_area.images[0].imageUrl | mediaUrlPipe) + ')'}"
                >

                </div>
                </nz-affix>
              </div>
              <div nz-col [nzSpan]="getPicAspectRatio(page) > 1 ? 8 : 16" style="padding-left: 32px">
                <div class="main-text-color font-bold text-lg mb-4">配置页面点读码</div>
                <div class="text-slate-400 font-light text-xs mb-4"></div>

                <div nz-row  *ngFor="let pageOids of pageConfig[i]; let oidIndex = index" class="mb-4">
                  <div nz-col [nzSpan]="20">
                    <nz-input-number
                      class="passenger-input w-full"
                      nz-input
                      placeholder="oid"
                      [(ngModel)]="pageConfig[i][oidIndex]"
                    />
                  </div>
                  <div nz-col [nzSpan]="4" class="flex flex-1 justify-center items-center cursor-pointer">
                    <span
                      nz-icon
                      style="font-size: 24px;"
                      nzType="minus-circle-o"
                      class="dynamic-delete-button"
                      (click)="removePageOidsField(i,oidIndex, $event)"
                    ></span>
                  </div>


                </div>
                <button nz-button nzType="dashed" class="add-button" (click)="addPageOidsField(i, $event)">
                  <span nz-icon nzType="plus"></span>
                  添加oid码
                </button>
              </div>
            </div>
          </div>

          </ng-template>
        </nz-tab>
      </nz-tabs>
    </div>
  </nz-spin>
</div>



